/**
 * Loads gtag.js and initializes GA4, only when a Measurement ID is
 * configured. Previously this was a hardcoded <script> tag in
 * public/index.html — same ID for local dev and production, so every
 * `npm start` sent real pageviews into the production property. Loading
 * it from JS instead means the production-only gate in analytics/index.js
 * actually works.
 */
export const loadGoogleAnalytics = (measurementId) => {
  if (!measurementId || window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // send_page_view:false — GA4's automatic pageview only fires once, on
  // this initial config call. React Router navigates client-side with no
  // full reload, so without this flag every subsequent route change would
  // be invisible to GA4. routes.js's router.subscribe() fires page_view
  // manually on every navigation instead, including this first one, so
  // nothing is missed and nothing double-counts.
  window.gtag('config', measurementId, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
};
